import React from 'react'
import { browserHistory,hashHistory } from 'react-router'
import { verifyAuth } from './Commons/Authentication'

export default class App extends React.Component {
  componentWillMount() {
    if (verifyAuth()) {
      // hashHistory.push('search')
    } else {
      // browserHistory.push('/#/')
      // window.location.reload()
      // console.log('reset')
    }
  }
  
  render() {
    return (

        <div id='app'>
          {this.props.children}
        </div>

    )
  }
}

App.propTypes = {
  children: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/app.js